import { Route, Routes } from 'react-router-dom';
import { NotFound, Driver } from '@pages';
import Protected from '@components/Protected';

function RoutesDriver() {
  return (
    <Protected>
      <Routes>
        <Route index element={<Driver />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesDriver;
